import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { NotificationService, NotificationSeverity } from '../services/notification.service';
import { LocalStorageUser } from '../interfaces/localStorage';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard {
  public user;

  constructor (
    private _router: Router,
    private _notifications: NotificationService
  ) {
    this.user = localStorage.getItem('USER');
  }

  canActivate(): Observable<boolean> {
    if (this.user === null) {
      this._router.navigateByUrl('/auth/company');
      return of(false);
    }

    const { type }: LocalStorageUser = JSON.parse(this.user);
    const isAdmin = type === 'admin';
    if (!isAdmin)  {
      this._notifications.create({
        severity: NotificationSeverity.warn,
        summary: 'No tienes permiso para acceder a esta página'
      });

      this._router.navigateByUrl('/priv');
    }
    return of(isAdmin);
  }

  canLoad(): Observable<boolean> {
    if (this.user === null) {
      this._router.navigateByUrl('/');
      return of(false);
    }

    const { type }: LocalStorageUser = JSON.parse(this.user);
    const isAdmin = type === 'admin';
    if (!isAdmin) {
      this._notifications.create({
        severity: NotificationSeverity.warn,
        summary: 'No tienes permiso para acceder a esta página'
      });

      this._router.navigateByUrl('/priv');
    }
    return of(isAdmin);
  }
}

export const canActivateAdmin = () => {
  return inject(AdminGuard).canActivate();
};

export const canLoadAdmin = () => {
  return inject(AdminGuard).canLoad();
};
